import { Column } from "react-table";

import {
  IProcessJob,
  IProcessJobError
} from "src/core/process-job/api/processJobs.api";
import { ITerminology } from "src/core/shared/api";

import { orderImportErrorsTableColumns } from "./orderImportErrorsTable";
import { orderExportErrorsTableColumns } from "./orderExportErrorsTable";
import { priceImportErrorsTableColumns } from "./priceImportFileErrorTable";
import { productImportErrorsTableColumns } from "./productImportFileErrorTable";
import { customerImportErrorsTableColumns } from "./customerImportFileErrorTable";
import { authorizePaymentsErrorsTableColumns } from "./authorizePaymentsImportErrorTable";
import { userImportErrorsTableColumns } from "./userImportFileErrorTable";
import { productApprovalImportErrorsTableColumns } from "./productApprovalFileErrorTable";
import { productReplacementErrorsTableColumns } from "./productReplacementErrorTable";

/**
 * Depending on the error type return a different table
 *
 * @param processJob
 * @returns
 */
export const getErrorRowColumnsByJob = (processJob: IProcessJob, terminology: ITerminology): Array<Column<IProcessJobError<any>>> => {
  switch (processJob.name) {
    case "api-import-order":
    case "import-file-order":
      return orderImportErrorsTableColumns({ terminology });

    case "authorize-off-session-payments":
      return authorizePaymentsErrorsTableColumns();

    case "api-export-order":
    case "order-export":
      return orderExportErrorsTableColumns();

    case "import-file-price":
    case "api-import-prices":
      return priceImportErrorsTableColumns({ terminology });

    case "import-file-product":
    case "import-file-nutrition":
      return productImportErrorsTableColumns({ terminology });

    case "api-import-customer":
    case "import-file-customer":
      return customerImportErrorsTableColumns();

    case "import-file-user":
      return userImportErrorsTableColumns();
    case "import-file-product-approval":
    case "api-import-product-approval":
      return productApprovalImportErrorsTableColumns({ terminology });

    case "product-replacement":
    case "global-product-replacement":
      return productReplacementErrorsTableColumns();
    default:
      return [];
  }
};
